import Cookies from "js-cookie";

import { B3_AUTH_COOKIE_NAME } from "@/lib/authenticatedFetch";
import type { InternalAlertPayload } from "@/lib/internalAlerts";

const INTERNAL_ALERTS_API_URL = process.env.NEXT_PUBLIC_B3OS_INTERNAL_ALERTS_URL || "https://internal-alert.b3os.org";

export async function sendInternalAlert(payload: InternalAlertPayload): Promise<void> {
  if (typeof window === "undefined") {
    return;
  }

  const jwt = Cookies.get(B3_AUTH_COOKIE_NAME);
  if (!jwt) {
    return;
  }

  try {
    const response = await fetch(`${INTERNAL_ALERTS_API_URL}/events`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify({
        ...payload,
        pageUrl: payload.pageUrl ?? window.location.href,
        pagePath: payload.pagePath ?? `${window.location.pathname}${window.location.search}`,
      }),
      keepalive: true,
    });

    if (!response.ok) {
      const responseText = await response.text();
      console.warn("[internal-alerts] Request was not accepted", {
        status: response.status,
        responseText,
      });
    }
  } catch (error) {
    console.warn("[internal-alerts] Failed to send alert", error);
  }
}
